'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { EmptyState } from '@/components/ui/empty-state';
import { Award01Icon } from '@/components/ui/icon/glyphs';

// ---------------------------------------------------------------------------
// Empty state — shown when the active tab returns zero entries. Each tab's
// empty title comes from a separate i18n key so PnL says "no traders yet",
// Boosters says "no boosters yet", Creators says "no creators yet", and
// Backers says "no backers yet". Every tab uses the shared <EmptyState>
// component (MOR-813 — the Traders/PnL tab no longer renders a to-do ramp).
// ---------------------------------------------------------------------------

export interface LeaderboardEmptyStateProps {
  tab: 'pnl' | 'boosters' | 'creators' | 'backers';
}
export function LeaderboardEmptyState(t0) {
  const $ = _c(5);
  const {
    tab
  } = t0;
  const t = useTranslations();
  const titleKey = tab === "pnl" ? "social.leaderboard.empty_title" : tab === "boosters" ? "social.boosters.empty_title" : tab === "backers" ? "social.backers.empty_title" : "social.creators.empty_title";
  let t1;
  if ($[0] !== t || $[1] !== titleKey) {
    t1 = t(titleKey);
    $[0] = t;
    $[1] = titleKey;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <EmptyState size="compact" icon={Award01Icon} title={t1} />;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}